module.exports = __webpack_public_path__ + "img/004.bf6f03c1.png";